module.exports = __webpack_public_path__ + "static/media/AWS_Configuration_Serra_Labs.98afc72f.pdf";